import { v3ApiHttp } from '@/services/api/tattle-http'
import type { DashboardDeploymentsResponse } from './dashboard-deployments.types'

const BASE_URL = '/admin/apps/merchant-dashboard/deployments'

/**
 * API service for the merchant-dashboard deployments Amplify is serving.
 */
export const dashboardDeploymentsAPI = {
  /**
   * List every deployment, unfiltered. Answers 404 where the endpoint is not offered (production).
   */
  async list(): Promise<DashboardDeploymentsResponse> {
    const response = await v3ApiHttp.get<DashboardDeploymentsResponse>(BASE_URL)
    return response.data
  }
}
